// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router/index';
import Toasted from 'vue-toasted';
import axios from 'axios';
import moment from 'moment';
//import accounting from 'accounting';

// cookies
Vue.use(require('vue-cookies'))

Vue.use(Toasted);
Vue.use(BootstrapVue);

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-8WPEZCD71D" },
}, router);

const isLocalAPI = false;
Vue.prototype.$configs = {
  api: isLocalAPI ? "http://localhost:9092" : "https://api-loccophieu.chungkhoannhanqua.vn",
  upload: "https://api4.loccophieu.com/assets/upload/images/",


};

Vue.prototype.$permissions = [
    { text: 'Admin', value: 'admin' },
    { text: 'Trang', value: 'page' },
    { text: 'Thư viện', value: 'media' },
    { text: 'Thành viên', value: 'user' },
    { text: 'Cài đặt', value: 'setting' }
];

const token = Vue.$cookies.get('token');
// Thiết lập token mặc định cho các yêu cầu Axios
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

// Interceptor để cập nhật token mỗi khi yêu cầu được gửi
axios.interceptors.request.use(config => {
  const token = Vue.$cookies.get('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});


Vue.prototype.$moment = moment;
Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.$userLogged = JSON.parse(localStorage.getItem('user')) || null;

//Global filter
Vue.filter('formatDate', function(value,format = "MM/DD/YYYY") {
    if (value) {
        return moment(String(value)).format(format)
    }
});


//Global components
import MediaModal from "./components/media";
import ptEditor from "./components/editor";
Vue.component('media-modal', MediaModal);
Vue.component('pt-editor', ptEditor);


let loginTime = null;

// Kiểm tra cookie khi trang được tải lên
if (Vue.$cookies.get('user')) {
  // Nếu cookie tồn tại và hợp lệ, đánh dấu thời gian đăng nhập
  loginTime = Date.now();
}

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    // Lưu thời gian đăng nhập khi người dùng truy cập trang đăng nhập
    loginTime = Date.now();
  }
  next();
});

// Quản lý events
window.addEventListener('beforeunload', handleBeforeUnload);

function handleBeforeUnload(event) {
  // Lấy User ID từ cookie
  const userId = Vue.$cookies.get('user');

  let timeSpent

  if (loginTime) {
    timeSpent = Date.now() - loginTime;
    Vue.$gtag.event('user_session', {
      event_category: 'session',
      event_label: 'User session',
      user_type: 'admin',
      user_id: userId?._id, // Thêm User ID vào dữ liệu sự kiện
      time_spent: timeSpent // Thêm thời gian đã trải qua vào dữ liệu sự kiện
    });
  }
  // Gửi sự kiện tùy chỉnh đến Google Analytics với User ID
  Vue.$gtag.event('browser_closed', {
    event_category: 'browser_events',
    event_label: 'Browser closed',
    user_type: 'admin',
    user_id: userId?._id, // Thêm User ID vào dữ liệu sự kiện
  });
}

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
});
